export default __webpack_public_path__ + "static/media/research-services-Mobile.0c623434.png";